import { render, staticRenderFns } from "./SAML.vue?vue&type=template&id=2551b9bf&scoped=true&"
import script from "./SAML.vue?vue&type=script&lang=js&"
export * from "./SAML.vue?vue&type=script&lang=js&"
import style0 from "./SAML.vue?vue&type=style&index=0&id=2551b9bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2551b9bf",
  null
  
)

export default component.exports